/* global angular */
( function () {
	'use strict';

	function ObsMath ( ) {
		return {
			'templateUrl'      : '/templates/components/math/math.html',
			'restrict'         : 'E',
			'replace'          : true,
			'controller'       : 'ObsMathCtrl',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'scope'            : {
				'itemList' : '=',
				'nameKey'  : '@',
				'itemKey'  : '@',
				'prefix'   : '@',
				'viewMode' : '=',
				'score'    : '=',

				'formulaName' : '='
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'obsMath', ObsMath );
} )( );
